import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InputAdornment from '@material-ui/core/InputAdornment';
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import Select from 'react-select';
import Check from "@material-ui/icons/Check";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import MaskedInput from 'react-text-mask';
import moment from "moment";
import CloseIcon from '@material-ui/icons/Close';
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import stylesHeader from "assets/jss/BeaktDay/views/agenda/headerAgendamentoRecorrente";
import { MaskDate, formateDate, validateDate, convertDate, MaskTime, MaskCPF, MaskCel } from "beaktShared/helpers/masks";
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(styles);
const useStylesHeader = makeStyles(stylesHeader);

export default function AgendamentoRecorrente({ prof, serv, closemodal, callback, selectedServico, obs, showmodal }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const classesHeader = useStylesHeader();

    const [session, setSession] = React.useState(useContext(SessionContext));

    const { register, handleSubmit, setValue, getValues, errors, clearError, setError } = useForm({ mode: "onChange" });
    const [profissional, setprofissional] = React.useState("");
    const [listSelectProfissional, setlistSelectProfissional] = React.useState([]);
    const [servico, setservico] = React.useState("");
    const [allservico, setallservico] = React.useState("");
    const [listSelectServico, setlistSelectServico] = React.useState([]);

    const [loading, setLoading] = React.useState(false);
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    const [etapa, setetapa] = React.useState(0)
    const [listaAgendamentos, setlistaAgendamentos] = React.useState([])

    useEffect(() => {

        clearError("emailcliente");

        setValue("cpfcliente", "");
        setValue("nomecliente", "");
        setValue("emailcliente", "");
        setValue("celularcliente", "");
        setValue("obs", "");
        setValue("duracao", "");
        setValue("profissional", "");
        setprofissional("");
        setValue("servico", "");
        setservico("");
        setetapa(0);
        setlistaAgendamentos([]);

        setdisabledEmail(false);
        setdisabledNome(false);
        setdisabledCPF(false);

    }, [showmodal]);

    useEffect(() => {
        setlistSelectProfissional(prof);
        setSession(getSessionCookie());
    }, [prof]);

    useEffect(() => {
        setlistSelectServico(serv);
        setallservico(serv);
        if (!(selectedServico === null)) {
            var vefifyExists = serv.filter(obj => {
                return obj.descricao === selectedServico;
            });
            if (vefifyExists[0]) {
                handleServicoChange(vefifyExists[0].servicoId);
                if (vefifyExists.length > 0)
                    setValue("duracao", vefifyExists[0].tempoExecucao);
                else
                    setValue("duracao", "");
            }
        }
        if (!(obs === null)) {
            setValue("obs", obs);
        }
    }, [serv]);

    const loadServicosbyProfissional = (idprofissional) => {

        var profissionalSelecionado = prof.filter(obj => {
            return obj.id === idprofissional;
        });

        if (profissionalSelecionado[0].servicos === null)
            return;

        var idsServicos = [];
        profissionalSelecionado[0].servicos.map(item => {
            idsServicos.push(item.servicoId);
            return true;
        })

        var servicoFiltered = [];
        idsServicos.map(id => {

            var servicobyProfissional = allservico.filter(obj => {
                return obj.servicoId === id;
            });
            if (servicobyProfissional !== null)
                servicoFiltered.push(...servicobyProfissional);

        })

        setlistSelectServico(servicoFiltered);

    }

    const intialValues = {
        cliente: '',
        profissional: '',
        servico: '',
        idcliente: 0,
    };

    const handleProfissionalChange = event => {
        let value = event
        setprofissional(value);
        setValue("profissional", value);
        loadServicosbyProfissional(value)
        if (value !== "")
            clearError("profissional");

        setservico(null);
        setValue("servico", null);
    };

    const handleServicoChange = event => {
        let value = event
        setservico(value);
        setValue("servico", value);
        if (value !== "")
            clearError("servico");

        var vefifyExists = listSelectServico.filter(obj => {
            return obj.servicoId === value;
        });

        if (vefifyExists.length > 0)
            setValue("duracao", vefifyExists[0].tempoExecucao);
        else
            setValue("duracao", "");

    };

    const hideModal = () => {
        closemodal();
        setdisabledEmail(false);
        setdisabledNome(false);
        setdisabledCPF(false);
    }

    const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
    const [disabledEmail, setdisabledEmail] = React.useState(false);
    const [disabledNome, setdisabledNome] = React.useState(false);
    const [disabledCPF, setdisabledCPF] = React.useState(false);

    const handleEmailChange = e => {
        let email = e.target.value;
        if (email === "")
            return;

        setloadingValidateEmail(true);
        const endPoint = "clientes/clientebyemailvenda/" + email + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
            if (result.status === 500) {
                showNotification(result.message, 'danger')
                setloadingValidateEmail(false);
                return false;
            }
            var values = getValues();
            if (result.status !== 200) {
                if (values.cpfcliente === "") {
                    setValue("idcliente", 0)
                    setValue("nomecliente", "");
                    setValue("celularcliente", "");

                }
                setloadingValidateEmail(false);
                return false;
            }
            if (result.data) {
                setValue("idcliente", result.data.clienteId);
                setValue("nomecliente", result.data.nome);
                setValue("cpfcliente", result.data.cpf);
                setValue("celularcliente", result.data.celular);

                if (result.data.cpf != "" && result.data.cpf != null) {
                    setdisabledCPF(true);
                }
                else {
                    setdisabledCPF(false);
                }
                setdisabledNome(true);
            }
            setloadingValidateEmail(false);
            return true;
        });
    }

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
    const handleCPFChange = e => {
        let cpf = e.target.value;

        if(intialValues.idcliente != 0 || (intialValues.id != 0 && cpf === "")){
            setValue("idcliente", 0);
            setValue("nomecliente", "");
            setValue("emailcliente", "");
            setValue("celularcliente", "");  
            setdisabledEmail(false);
            setdisabledNome(false);  
        }
        
        if (cpf === "")
            return;
        if (cpf.length < 14)
            return;

        setloadingValidateCPF(true);
        const endPoint = "clientes/clientebycpfvenda/" + cpf + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
            if (result.status === 500) {
                showNotification(result.message, 'danger')
                setloadingValidateCPF(false);
                return false;
            }
            if (result.status !== 200) {
                setValue("idcliente", 0);
                setValue("nomecliente", "");
                setValue("emailcliente", "");
                setValue("celularcliente", "");
                setdisabledEmail(false);
                setdisabledNome(false);  

                setloadingValidateCPF(false);
                return false;
            }
            if (result.data) {
                setValue("idcliente", result.data.clienteId);
                setValue("nomecliente", result.data.nome);
                setValue("emailcliente", result.data.email);
                setValue("celularcliente", result.data.celular);

                if (result.data.email != "" && result.data.email != null) {
                    setdisabledEmail(true);
                }
                else {
                    setdisabledEmail(false);
                }
                setdisabledNome(true);
            }
            setloadingValidateCPF(false);
        });
    }

    const onlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };

    const validateStep0 = () => {
        let data = getValues();
        let retorno = true;

        if (data.emailcliente == "") {
            retorno = false;
            setError("emailcliente", "required", t('label.required'));
        }

        if (data.nomecliente == "") {
            retorno = false;
            setError("nomecliente", "required", t('label.required'));
        }

        if (profissional == "") {
            retorno = false;
            setError("profissional", "required");
        }

        if (servico == "") {
            retorno = false;
            setError("servico", "required");
        }

        if (data.duracao === "") {
            retorno = false;
            setError("duracao", "required", t('label.required'));
        }
        return retorno;
    }

    const handleEtapa = (number) => {
        if (number === 1) {
            if (!validateStep0())
                return;
            setlistaAgendamentos([]);
        }

        setetapa(number);
    }

    const [loadingAddAgendamento, setloadingAddAgendamento] = React.useState(false);
    const handleAgendar = () => {
        let data = getValues();

        let validacao = true;
        if (!validateDate(data.data)) {
            validacao = false;
            setError("data", "invaliddate", t('error_message.invalid_date'));
        }

        if (data.hora.length != 5) {
            validacao = false;
            setError("hora", "invaliddate", t('error_message.invalid_date'));
        }

        if (!validacao)
            return;

        var dataC = convertDate(data.data);

        let agendamento_validate = {
            agendamentoId: 0,
            data: dataC,
            horaInicio: data.hora,
            horaFim: "00:00:00",
            tempoDuracao: parseInt(data.duracao),
            servicoId: data.servico,
            clienteId: parseInt(data.idcliente),
            emailcliente: data.emailcliente,
            nomecliente: data.nomecliente,
            cpfcliente: data.cpfcliente,
            celularcliente: data.celularcliente,
            profissionalId: data.profissional,
            obs: data.obs,
            statusAgendamento: 0,
            usuarioCadastroId: session.id,
            estabelecimentoId: session.estabelecimentoId
        }

        UsePostApi("agendamentos/validaagendamento", agendamento_validate).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, "danger");
                return false;
            }
            if (result.data === "") {
                let agendamentos = [];
                listaAgendamentos.map(item => {
                    agendamentos.push({
                        descricao: item.descricao,
                        data: item.data,
                        hora: item.hora
                    });
                });

                let itemadd = {
                    descricao: data.data + " " + data.hora,
                    data: convertDate(data.data),
                    hora: data.hora
                }

                if (agendamentos.filter(f => f.descricao == itemadd.descricao).length > 0) {
                    showNotification(t('agenda.scheduling_already_done'), "danger");
                    return;
                }

                agendamentos.push(itemadd);

                setlistaAgendamentos(agendamentos);

                setValue("data", "");
                setValue("hora", "");
            }
            else {
                showNotification(result.data, "warning");
                return;
            }
            // setloadingValidateEmail(false);
            return true;
        });
    }

    const handleDeleteAgendamento = (descricao) => {
        let agendamentos = listaAgendamentos.filter(f => { return f.descricao != descricao });
        setlistaAgendamentos(agendamentos);
    }

    const onSubmit = data => {

        if (listaAgendamentos.length === 0) {
            showNotification(t("agenda.Inform_the_dates_and_scheduling_times"), "warning");
            return false;
        }

        let obj = [];
        listaAgendamentos.map((item) => {

            obj.push({
                agendamentoId: 0,
                data: item.data,
                horaInicio: item.hora,
                horaFim: "00:00:00",
                tempoDuracao: parseInt(data.duracao),
                servicoId: data.servico,
                clienteId: parseInt(data.idcliente),
                emailcliente: data.emailcliente,
                nomecliente: data.nomecliente,
                cpfcliente: data.cpfcliente,
                celularcliente: data.celularcliente,
                profissionalId: data.profissional,
                obs: data.obs,
                statusAgendamento: 0,
                usuarioCadastroId: session.id,
                estabelecimentoId: session.estabelecimentoId
            })
        })

        let endPoint = 'agendamentos/saveagendamentosrecorrentes';
        setLoading(true);
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 201) {
                showNotification(result.message, 'danger');
                setLoading(false);
                return false;
            }

            if (result.data.sucesso) {
                callback();
                setLoading(false);
                closemodal();
                return true;
            }
            else {
                var notify = result.data.mensagem;
                if (result.data.erros != null) {
                    result.data.erros.map((item) => {
                        notify += "<br />" + item
                    });
                }
                showNotification(notify, "warning");
            }
        });

    };

    return (
        <CardBody>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }


            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <h3>{t('agenda.recurring_scheduling')}</h3>
                        <label>{t('agenda.please_enter_data')}.</label>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <Card>
                            <CardBody className={classesHeader.cardHeaderProcesso}>
                                <GridContainer>
                                    <GridItem xs={6} sm={6} md={6} className={classesHeader.gridHeader}>
                                        <div className={classesHeader.boxProcess}>
                                            <div className={classesHeader.boxItem}>
                                                <div className={classesHeader.iconItem + " " + classesHeader.iconCheck}>
                                                    <Check className={classesHeader.icoSize} />
                                                </div>
                                                {t('avaliation.client_data')}
                                            </div>
                                            <div className={etapa === 0 ? classesHeader.lineProcessRight + " " + classesHeader.lineLight : classesHeader.lineProcessRight + " " + classesHeader.lineDark} ></div>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} className={classesHeader.gridHeader}>
                                        <div className={classesHeader.boxProcess}>
                                            <div className={classesHeader.boxItem}>
                                                <div className={etapa < 1 ? classesHeader.iconItem + " " + classesHeader.iconUnCheck : classesHeader.iconItem + " " + classesHeader.iconCheck}>
                                                    <Check className={etapa < 1 ? classesHeader.noneCheck : classesHeader.icoSize} />
                                                </div>
                                                {t('agenda.recurrences')}
                                            </div>
                                            <div className={etapa < 1 ? classesHeader.lineProcessLeft + " " + classesHeader.lineLight : classesHeader.lineProcessLeft + " " + classesHeader.lineDark} ></div>
                                            <div className={etapa >= 1 ? classesHeader.lineProcessRight + " " + classesHeader.lineDark : classesHeader.lineProcessRight + " " + classesHeader.lineLight} ></div>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <br />
                <div style={{ display: etapa === 0 ? "block" : "none" }}>
                    <GridContainer>
                        <input className={classes.hidden} defaultValue={intialValues.idcliente} name="idcliente" ref={register} />
                        <GridItem xs={12} sm={4} md={4}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.cpf ? true : false}
                                    label="CPF"
                                    variant="outlined"
                                    onBlur={handleCPFChange}
                                    inputRef={register({ required: false })}
                                    name="cpfcliente"
                                    defaultValue={intialValues.cpf}
                                    disabled={disabledCPF}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        inputComponent: MaskCPF,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {errors.cpf &&
                                    <FormHelperText className={classes.labelRootError}>
                                        <span>{errors.cpf.message} </span>
                                    </FormHelperText>}
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.emailcliente ? true : false}
                                    label={t('label.client_email') + " *"}
                                    variant="outlined"
                                    onBlur={handleEmailChange}
                                    inputRef={register({
                                        required: "E-mail é Obrigatório",
                                        pattern: {
                                            value: /^\S+@\S+$/i,
                                            message: t('label.invalid_email')
                                        },
                                        maxLength: {
                                            value: 50,
                                            message: t('label.enter_a_maximum_of_50_characters')
                                        }
                                    })}
                                    name="emailcliente"
                                    defaultValue={intialValues.cliente}
                                    disabled={disabledEmail}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {loadingValidateEmail && <LoadingIcon className="rotate" />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.emailcliente && <span> {errors.emailcliente.message} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.nomecliente ? true : false}
                                    label={t('label.client_name') + " *"}
                                    variant="outlined"
                                    inputRef={register({ required: true })}
                                    name="nomecliente"
                                    defaultValue={intialValues.nomecliente}
                                    disabled={disabledNome}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 100 }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.nomecliente && <span>{t('label.required')}</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.celularcliente ? true : false}
                                    label={t('label.cell_phone')}
                                    variant="outlined"
                                    inputRef={register({ required: false })}
                                    name="celularcliente"
                                    defaultValue={intialValues.celularcliente}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ inputComponent: MaskCel }}
                                />
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={5} md={5}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.profissional ? "select__label select__label_error" : "select__label"}>
                                    {t('label.professional')} *
                                </label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.profissional ? true : false)}
                                    isSearchable={true}
                                    name="profissional"
                                    placeholder="Selecione..."
                                    options={listSelectProfissional}
                                    value={listSelectProfissional.filter(({ id }) => id === profissional)}
                                    getOptionLabel={({ title }) => title}
                                    getOptionValue={({ id }) => id}
                                    onChange={(value) => handleProfissionalChange(value.id !== null ? value.id : "")}

                                    ref={() => register(
                                        { name: "profissional" },
                                        { required: true })
                                    }
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.profissional && <span> {t('label.required')} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.servico ? "select__label select__label_error" : "select__label"}>{t('label.service')}  *</label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.servico ? true : false)}
                                    isSearchable={true}
                                    name="servico"
                                    placeholder="Selecione..."
                                    options={listSelectServico}
                                    value={listSelectServico.filter(({ servicoId }) => servicoId === servico)}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ servicoId }) => servicoId}
                                    onChange={(value) => handleServicoChange(value.servicoId !== null ? value.servicoId : "")}

                                    ref={() => register(
                                        { name: "servico" },
                                        { required: true })
                                    }
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.servico && <span> {t('label.required')} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={2} md={2}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.duracao ? true : false}
                                    label={t('label.duration_minutes') + " *"}
                                    variant="outlined"
                                    name="duracao"
                                    inputRef={register({ required: true })}
                                    defaultValue={intialValues.duracao}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 3 }}
                                    onInput={(e) => onlyNumbers(e)}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.duracao && <span>{t('label.required')}</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.obs ? true : false}
                                    label={t('label.obs') + " *"}
                                    variant="outlined"
                                    inputRef={register}
                                    name="obs"
                                    defaultValue={intialValues.obs}
                                    InputLabelProps={{ shrink: true }}
                                    multiline
                                    rowsMax="3"
                                    rows="2"
                                    inputProps={{ maxLength: 500 }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.obs && <span>Erro</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <div className={classes.textCenter}>
                                <Button onClick={hideModal} color="transparent" className={classes.updateProfileButton}>
                                    {t('button.cancel')}
                                </Button>
                                <Button type="button" onClick={() => handleEtapa(1)} color="primary" className={classes.updateProfileButton}>
                                    {t('label.advance')}  {loading && <div> ... {t('label.loading')}</div>}
                                </Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
                <div style={{ display: etapa === 1 ? "block" : "none" }}>
                    <GridContainer>
                        <GridItem xs={4} sm={3} md={3}>
                            <br />
                            <FormControl fullWidth >
                                <TextField
                                    error={errors.data ? true : false}
                                    label={t('label.date') + " *"}
                                    variant="outlined"
                                    inputRef={register({ required: false })}
                                    name="data"
                                    defaultValue={intialValues.data}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        inputComponent: MaskDate,
                                    }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.data && <span>{errors.data.message}</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={4} sm={3} md={3}>
                            <br />
                            <FormControl fullWidth >
                                <TextField
                                    error={errors.hora ? true : false}
                                    label={t('agenda.start_time') + " *"}
                                    variant="outlined"
                                    inputRef={register({ required: false })}
                                    name="hora"
                                    defaultValue={intialValues.hora}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        inputComponent: MaskTime,
                                    }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.hora && <span>Obrigatório</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={4} sm={3} md={3}>
                            <br />
                            <Button type="button" onClick={() => handleAgendar()} color="primary" className={classes.updateProfileButton}>
                                {t('button.schedule')}  {loadingAddAgendamento && <div> ... {t('label.loading')}</div>}
                            </Button>
                        </GridItem>
                    </GridContainer>

                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <h5>{t('agenda.schedule_list')}</h5>
                        </GridItem>
                        {listaAgendamentos.map(item => (
                            <GridItem xs={6} sm={4} md={3} key={item.descricao}>
                                <Button color="transparent" round className={classes.marginRight}
                                    onClick={() => handleDeleteAgendamento(item.descricao)}>
                                    <CloseIcon className={classes.icons} /> {item.descricao}
                                </Button>
                            </GridItem>
                        ))}
                    </GridContainer>
                    <GridContainer justify="center">
                        <br /><br />
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <div className={classes.textCenter}>
                                <Button onClick={() => handleEtapa(0)} color="transparent" className={classes.updateProfileButton}>
                                    {t('label.return')}
                                </Button>
                                <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                    {t('button.to_save')}  {loading && <div> ... {t('label.loading')}</div>}
                                </Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
            </form>
        </CardBody>
    );
}
